import styled from 'styled-components';

export const NumberOfStayWrapper = styled.div`
  height: 42px;
`;

export const NumberOfStayDays = styled.div`
  white-space: nowrap;
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 1.375em;
  line-height: 1.375em;

  color: #17181a;
`;

export const NumberOfStayDaysWithFlight = styled.div`
  white-space: nowrap;
  font-family: 'Backpack', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;

  color: #919499;
`;
